import React, { useCallback, useMemo, useRef, useState } from "react"
import { IPianoContext, PianoContext } from "."
import { mockedUser } from "../Raffle/mock"
import PianoDebugView from "./PianoDebugView"

const WithMockPiano: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [ pianoState, setPianoState ] = useState<Omit<IPianoContext, "forceLogin">>({
    loginCooldown: false,
    state: "none",    
  })
  const [ mockSetup, setMockSetup ] = useState({ willSucceedLoginCall: true })
  const mockSetupRef = useRef(mockSetup)
  mockSetupRef.current = mockSetup

  const forceLogin = useCallback<IPianoContext["forceLogin"]>((onSuccess) => {
    setPianoState((prev) => ({...prev, loginCooldown: true}))
    window.setTimeout(() => {
      if (mockSetupRef.current.willSucceedLoginCall) {
        setPianoState((prev) => ({...prev, loginCooldown: false,
          state: "initialized",
          userInfo: {
            user: mockedUser,
            token: "___mockedToken"
          }
        }))
        onSuccess(mockedUser, "___mockedToken")
      } else {
        setPianoState((prev) => ({...prev, loginCooldown: false, userInfo: undefined}))
      }

    }, 2000)
  }, [])

  const fakeInitializeWithLoggedInUser = () => {
    setPianoState((prev) => ({...prev, state: "initializing"}))
    window.setTimeout(() => {
      setPianoState((prev) => ({
        ...prev,
        state: "initialized",
        userInfo: { user: mockedUser, token: "__mockedToken"}
      }))
    }, 2000)
  }

  const fakeInitializeWithNotLoggedInUser = () => {
    setPianoState((prev) => ({...prev, state: "initializing"}))
    window.setTimeout(() => {
      setPianoState((prev) => ({
        ...prev,
        state: "initialized",
        userInfo: undefined
      }))
    }, 2000)
  }

  const resetInitialization = () => {
    setPianoState({ loginCooldown: false, state: "none" })
  }

  const contextVal = useMemo(() => ({
    ...pianoState,
    forceLogin
  }), [pianoState, forceLogin])

  return <PianoContext.Provider value={contextVal}>
    <PianoDebugView
      additionalActions={[
        ["init -> user", fakeInitializeWithLoggedInUser],
        ["init -> not logged in", fakeInitializeWithNotLoggedInUser],
        ["reset", resetInitialization],
        ["toggle will-login-succeed", () => setMockSetup((prev) => ({...prev, willSucceedLoginCall: !prev.willSucceedLoginCall}))]
      ]}
      additionalState={[
        ["willSucceedLoginCall", mockSetup.willSucceedLoginCall ? "YES" : "no"]
      ]}/>
    {children}
  </PianoContext.Provider>
}

export default WithMockPiano
